import React, { Component, useState } from "react";

import { CrfContext } from "../../CrfContext";

import SideNav from "../sidenav/Sidenav.js";
import { Link } from "react-router-dom";
import TransitionsModal from "../modal/modal";
import Pagination from "./Pagination.js";
import moment from "moment";
import AllRequestPagination from "./AllRequestPagination.js";

import { DownloadPhase1, DownloadPhase2 } from "../downloadAsCSV/downloadAsCsv";
import "./MyRequest.css";

import axios from "axios";
import CustomText from "./customText";
import CustomText2 from "./customText2";

export class MyRequest extends Component {
  state = {
    modalState: false,
    approvedRequest: false,
    allRequests: [],
    approvedRequests: false,
    requestorId: "",

    toggleAllRequests: true,
    toggleForTransmittal: false,
    toggleForReview: false,
    toggleForEndorsement: false,
    toggleReturned: false,
    toggleRejected: false,
    toggleOnHold: false,

    toggleInProcess: false,
    toggleCheckPreparation: false,
    toggleCheckPrepared: false,
    toggleCheckAvailable: false,
    toggleReleased: false,
    orUploads: [],
    phase1: true,
    phase2: false,
    grandTotal: "0.00",
  };

  componentDidMount() {
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        const newRequest = response.data.data;
        axios({
          method: "GET",
          url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
          headers: {
            "Api-Key":
              "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
            Authorization: `Bearer ${localStorage.token}`,
          },
        }).then((userInfo) => {
          let allRequests = [];
          for (let request of newRequest) {
            if (request.requestor._id === userInfo.data.data._id) {
              allRequests.push(request);
            }
          }
          this.setState({
            allRequests: allRequests.reverse(),
          });
        });
      })
      .catch((error) => {
          
      });

    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/orUpload`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        const newRequest = response.data.data;
        this.setState({
          orUploads: newRequest,
        });
      })
      .catch((error) => {
        //   
      });
  }

  getOrNumber = (crfNo) => {
    const orObj = this.state.orUploads.filter((data) => data.crfNo === crfNo);
    if (orObj.length > 0) {
      return orObj[0].orNo;
    } else {
      return "N/A";
    }
  };
  handleAllRequest = (e) => {
    e.preventDefault();
    this.setState({
      toggleAllRequests: true,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleOnHold: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grandTotal: "0.00",
    });

    document.getElementById("allSelected").style.borderBottom = "3px solid red";
    document.getElementById("allSelected").style.color = "black";

    if (this.state.phase1 === true) {
      document.getElementById("onHoldSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("approvedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("approvedSelected").style.color = "gray";

      document.getElementById("transmittedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("transmittedSelected").style.color = "gray";

      document.getElementById("reviewedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("reviewedSelected").style.color = "gray";

      document.getElementById("forEndorsementSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("forEndorsementSelected").style.color = "gray";

      document.getElementById("rejectedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("rejectedSelected").style.color = "gray";
    } else {
      document.getElementById("inProcessSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("inProcessSelected").style.color = "gray";

      document.getElementById("checkPreparationSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparationSelected").style.color = "gray";

      document.getElementById("checkPreparedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparedSelected").style.color = "gray";

      document.getElementById("checkAvailableSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkAvailableSelected").style.color = "gray";

      document.getElementById("releasedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("releasedSelected").style.color = "gray";
    }
  };

  handleApprovedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "For Transmittal"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: true,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("approvedSelected").style.color = "black";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleTransmittedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "For Review"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: true,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });
    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("transmittedSelected").style.color = "black";

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleReviewedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "For Endorsement"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: true,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("reviewedSelected").style.color = "black";

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("onHoldSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleOnHoldRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "On Hold"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: true,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("onHoldSelected").style.color = "black";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleForReturnedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "Returned"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleEndorsed: false,
      toggleReturned: true,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("forEndorsementSelected").style.color = "black";

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("rejectedSelected").style.color = "gray";
  };

  handleForRejectedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "Rejected"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleEndorsed: false,
      toggleReturned: false,
      toggleRejected: true,
      toggleOnHold: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("rejectedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("rejectedSelected").style.color = "black";

    document.getElementById("onHoldSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";

    document.getElementById("forEndorsementSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("forEndorsementSelected").style.color = "gray";

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("approvedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("approvedSelected").style.color = "gray";

    document.getElementById("transmittedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("transmittedSelected").style.color = "gray";

    document.getElementById("reviewedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("reviewedSelected").style.color = "gray";
  };

  handleInProcessRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "In Process"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: true,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("inProcessSelected").style.color = "black";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparationSelected").style.color = "gray";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparedSelected").style.color = "gray";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkAvailableSelected").style.color = "gray";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("releasedSelected").style.color = "gray";
  };

  handleCheckPreparationRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "Check Preparation"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: false,
      toggleCheckPreparation: true,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("inProcessSelected").style.color = "gray";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("checkPreparationSelected").style.color = "black";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparedSelected").style.color = "gray";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkAvailableSelected").style.color = "gray";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("releasedSelected").style.color = "gray";
  };

  handleCheckPreparedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "Check Prepared"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: true,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("inProcessSelected").style.color = "gray";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparationSelected").style.color = "gray";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("checkPreparedSelected").style.color = "black";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkAvailableSelected").style.color = "gray";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("releasedSelected").style.color = "gray";
  };

  handleCheckAvailableRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "Check Available"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: true,
      toggleReleased: false,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("inProcessSelected").style.color = "gray";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparationSelected").style.color = "gray";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparedSelected").style.color = "gray";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("checkAvailableSelected").style.color = "black";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("releasedSelected").style.color = "gray";
  };

  handleReleasedRequest = (e) => {
    e.preventDefault();
    let totalNetPrice = 0;
    for (const obj of this.state.allRequests.filter(
      (crf) => crf.status === "Released"
    )) {
      totalNetPrice = parseFloat(obj.totalNetPrice) + parseFloat(totalNetPrice);
    }
    this.setState({
      toggleAllRequests: false,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: true,
      grandTotal: totalNetPrice.toFixed(2),
    });

    document.getElementById("allSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("allSelected").style.color = "gray";

    document.getElementById("inProcessSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("inProcessSelected").style.color = "gray";

    document.getElementById("checkPreparationSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparationSelected").style.color = "gray";

    document.getElementById("checkPreparedSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkPreparedSelected").style.color = "gray";

    document.getElementById("checkAvailableSelected").style.borderBottom =
      "3px solid black";
    document.getElementById("checkAvailableSelected").style.color = "gray";

    document.getElementById("releasedSelected").style.borderBottom =
      "3px solid red";
    document.getElementById("releasedSelected").style.color = "black";
  };

  handlePhase1 = () => {
    this.setState({
      phase1: true,
      phase2: false,

      toggleAllRequests: true,
      toggleInProcess: false,
      toggleCheckPreparation: false,
      toggleCheckPrepared: false,
      toggleCheckAvailable: false,
      toggleReleased: false,
      grandTotal: "0.00",
    });

    document.getElementById("ph1Btn").style.background = "#ee3124";
    document.getElementById("ph1Btn").style.color = "white";
    document.getElementById("ph2Btn").style.background = "gray";

    document.getElementById("allSelected").style.borderBottom = "3px solid red";
    document.getElementById("allSelected").style.color = "black";

    if (this.state.phase1 === true) {
      document.getElementById("approvedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("approvedSelected").style.color = "gray";

      document.getElementById("transmittedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("transmittedSelected").style.color = "gray";

      document.getElementById("reviewedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("reviewedSelected").style.color = "gray";

      document.getElementById("forEndorsementSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("forEndorsementSelected").style.color = "gray";

      document.getElementById("rejectedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("rejectedSelected").style.color = "gray";
    } else {
      document.getElementById("inProcessSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("inProcessSelected").style.color = "gray";

      document.getElementById("checkPreparationSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparationSelected").style.color = "gray";

      document.getElementById("checkPreparedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparedSelected").style.color = "gray";

      document.getElementById("checkAvailableSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkAvailableSelected").style.color = "gray";

      document.getElementById("releasedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("releasedSelected").style.color = "gray";
    }
  };

  handlePhase2 = () => {
    this.setState({
      phase2: true,
      phase1: false,
      toggleAllRequests: false,
      toggleForTransmittal: false,
      toggleForReview: false,
      toggleForEndorsement: false,
      toggleReturned: false,
      toggleRejected: false,
      toggleOnHold: false,
      grandTotal: "0.00",
    });
    document.getElementById("ph2Btn").style.background = "#ee3124";
    document.getElementById("ph2Btn").style.color = "white";
    document.getElementById("ph1Btn").style.background = "gray";

    document.getElementById("allSelected").style.borderBottom = "3px solid red";
    document.getElementById("allSelected").style.color = "black";

    if (this.state.phase1 === true) {
      document.getElementById("approvedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("approvedSelected").style.color = "gray";

      document.getElementById("transmittedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("transmittedSelected").style.color = "gray";

      document.getElementById("reviewedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("reviewedSelected").style.color = "gray";

      document.getElementById("forEndorsementSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("forEndorsementSelected").style.color = "gray";

      document.getElementById("rejectedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("rejectedSelected").style.color = "gray";
    } else {
      document.getElementById("inProcessSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("inProcessSelected").style.color = "gray";

      document.getElementById("checkPreparationSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparationSelected").style.color = "gray";

      document.getElementById("checkPreparedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkPreparedSelected").style.color = "gray";

      document.getElementById("checkAvailableSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("checkAvailableSelected").style.color = "gray";

      document.getElementById("releasedSelected").style.borderBottom =
        "3px solid black";
      document.getElementById("releasedSelected").style.color = "gray";
    }
  };
  handleModal = () => {
    this.setState({
      modalState: !this.state.modalState,
    });
  };
  formatDate = (date) => {
    let dateArray = "";
    let month = "";
    let day = "";
    let year = "";

    if (date.length === 10) {
      dateArray = date.split("/");
      month = dateArray[0];
      day = dateArray[1];
      year = dateArray[2];
    } else {
      dateArray = date.split("-");
      month = dateArray[1];
      day = dateArray[2].substring(0, 2);
      year = dateArray[0];
    }
    switch (month) {
      case "02":
        month = "Feb";
        break;
      case "03":
        month = "Mar";
        break;
      case "04":
        month = "Apr";
        break;
      case "05":
        month = "May";
        break;
      case "06":
        month = "Jun";
        break;
      case "07":
        month = "Jul";
        break;
      case "08":
        month = "Aug";
        break;
      case "09":
        month = "Sep";
        break;
      case "10":
        month = "Oct";
        break;
      case "11":
        month = "Nov";
        break;
      case "12":
        month = "Dec";
        break;
      default:
        month = "Jan";
    }
    return `${month} ${day}, ${year}`;
  };

  addCommas(nStr) {
    nStr += "";
    var x = nStr.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }

  renderHead() {
    if (this.state.toggleReleased) {
      return (
        <div className="myRequestTableHeader">
          <div className="tHead">CRF#</div>
          <div className="tHead">Due date</div>
          <div className="tHead">Vendor</div>
          <div className="tHead">Check Amount</div>
          <div className="tHead">Check available date</div>
          <div className="tHead">Date Released</div>
          <div className="tHead">Department</div>
          {/* <div className='tHead'>OR#</div> */}
        </div>
      );
    } else if (this.state.toggleCheckAvailable) {
      return (
        <div className="myRequestTableHeader">
          <div className="tHead">CRF#</div>
          <div className="tHead">Date created</div>
          <div className="tHead">Due date</div>
          <div className="tHead">Vendor</div>
          <div className="tHead">Check Amount</div>
          <div className="tHead">Check date</div>
          <div className="tHead">Check number</div>
          <div className="tHead" style={{ padding: "0px" }}>
            Check available date
          </div>
          <div className="tHead">Department</div>
        </div>
      );
    } else if (this.state.toggleCheckPrepared) {
      return (
        <div className="myRequestTableHeader">
          <div className="tHead">CRF#</div>
          <div className="tHead">Date created</div>
          <div className="tHead">Expected completion date</div>
          <div className="tHead">Due date</div>
          <div className="tHead">Vendor</div>
          <div className="tHead">Check amount</div>
        </div>
      );
    } else if (this.state.toggleCheckPreparation) {
      return (
        <div className="myRequestTableHeader">
          <div className="tHead">CRF#</div>
          <div className="tHead">Date created</div>
          <div className="tHead">Due date</div>
          <div className="tHead">Vendor</div>
          <div className="tHead">Check amount</div>
          <div className="tHead">Department</div>
        </div>
      );
    } else if (this.state.toggleInProcess) {
      return (
        <div className="myRequestTableHeader">
          <div className="tHead">CRF#</div>
          <div className="tHead">Date created</div>
          <div className="tHead">Due date</div>
          <div className="tHead">Vendor</div>
          <div className="tHead">Amount requested</div>
          <div className="tHead">Department</div>
        </div>
      );
    } else {
      return (
        <div className="myRequestTableHeader">
          <div className="tHead">CRF#</div>
          <div className="tHead">Date Created</div>
          {this.state.toggleReleased ? (
            <div className="tHead">Date Released</div>
          ) : (
            <div className="tHeadExp" style={{ padding: "0px" }}>
              Expected Completion Date
            </div>
          )}
          <div className="tHead">Due date</div>
          <div className="tHead">Vendor</div>
          <div className="tHead">Amount Requested</div>
          <div className="tHead">Department</div>
          <div className="tHead">Status</div>
          <div className="tHead">Request Type</div>
        </div>
      );
    }
  }

  renderTableBody(allRequests) {
    if (this.state.toggleReleased) {
      return (
        <div>
          <Pagination
            allRequests={allRequests}
            toggleReleased={this.state.toggleReleased}
            formatDate={this.formatDate}
            getOrNumber={this.getOrNumber}
          />
        </div>
      );
    } else if (this.state.toggleCheckAvailable) {
      return allRequests.map((requestsArray) => (
        <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
          <div className="tableData" style={{ height: "60px" }}>
            <div className="tData">
              <h4>{requestsArray.crfNo}</h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.creationDate.slice(4, 16)}</h4>
            </div>
            <div className="tData">
              <h4>{moment(requestsArray.dueDate).format("MM/DD/YYYY")}</h4>
            </div>
            <div className="tData2">
              <CustomText>{requestsArray.vendor.bpName}</CustomText>
            </div>
            <div className="tData">
              <h4>
                <span>&#8369;</span>
                {requestsArray.totalNetPrice
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </h4>
            </div>
            <div className="tData">
              <h4>{moment(requestsArray.checkDate).format("MM/DD/YYYY")}</h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.checkNo}</h4>
            </div>
            <div className="tData">
              <h4>
                {moment(requestsArray.checkAvailableDate).format("MM/DD/YYYY")}
              </h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.department.centerName}</h4>
            </div>
          </div>
        </Link>
      ));
    } else if (this.state.toggleCheckPrepared) {
      return allRequests.map((requestsArray) => (
        <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
          <div className="tableData" style={{ height: "60px" }}>
            <div className="tData">
              <h4>{requestsArray.crfNo}</h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.creationDate.slice(4, 16)}</h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.expectedCompletionDate.slice(4, 16)}</h4>
            </div>
            <div className="tData">
              <h4>{moment(requestsArray.dueDate).format("MM/DD/YYYY")}</h4>
            </div>
            <div className="tData">
              <CustomText2>{requestsArray.vendor.bpName}</CustomText2>
            </div>
            <div className="tData">
              <h4>
                <span>&#8369;</span>
                {requestsArray.totalNetPrice
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </h4>
            </div>
          </div>
        </Link>
      ));
    } else if (this.state.toggleCheckPreparation) {
      return allRequests.map((requestsArray) => (
        <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
          <div className="tableData" style={{ height: "60px" }}>
            <div className="tData">
              <h4>{requestsArray.crfNo}</h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.creationDate.slice(4, 16)}</h4>
            </div>
            <div className="tData">
              <h4>{moment(requestsArray.dueDate).format("MM/DD/YYYY")}</h4>
            </div>
            <div className="tData">
              <CustomText2>{requestsArray.vendor.bpName}</CustomText2>
            </div>
            <div className="tData">
              <h4>
                <span>&#8369;</span>
                {requestsArray.totalNetPrice
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.department.centerName}</h4>
            </div>
          </div>
        </Link>
      ));
    } else if (this.state.toggleCheckPreparation) {
      return allRequests.map((requestsArray) => (
        <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
          <div className="tableData" style={{ height: "60px" }}>
            <div className="tData">
              <h4>{requestsArray.crfNo}</h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.creationDate.slice(4, 16)}</h4>
            </div>
            <div className="tData">
              <h4>{moment(requestsArray.dueDate).format("MM/DD/YYYY")}</h4>
            </div>
            <div className="tData">
              <CustomText2>{requestsArray.vendor.bpName}</CustomText2>
            </div>
            <div className="tData">
              <h4>
                <span>&#8369;</span>
                {requestsArray.totalNetPrice
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.department.centerName}</h4>
            </div>
          </div>
        </Link>
      ));
    } else if (this.state.toggleInProcess) {
      return allRequests.map((requestsArray) => (
        <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
          <div className="tableData" style={{ height: "60px" }}>
            <div className="tData">
              <h4>{requestsArray.crfNo}</h4>
            </div>
            <div className="tData">
              <h4>{requestsArray.creationDate.slice(4, 16)}</h4>
            </div>
            <div className="tData">
              <h4>{moment(requestsArray.dueDate).format("MM/DD/YYYY")}</h4>
            </div>
            <div className="tData">
              <CustomText2>{requestsArray.vendor.bpName}</CustomText2>
            </div>
            <div className="tData">
              <h4>
                <span>&#8369;</span>
                {requestsArray.totalNetPrice
                  .toFixed(2)
                  .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
              </h4>
            </div>
            <div className="tData">
              <CustomText2>{requestsArray.department.centerName}</CustomText2>
            </div>
          </div>
        </Link>
      ));
    } else {
      return (
        <div>
          <AllRequestPagination
            allRequests={allRequests}
            toggleReleased={this.state.toggleReleased}
            formatDate={this.formatDate}
            grandTotal={this.addCommas(this.state.grandTotal)}
          />
        </div>
      );
    }
  }
  render() {
    let allRequests = [];
    // if(this.state.toggleAllRequests){
    //     allRequests = (this.state.allRequests).filter( crf => crf )
    //     //   
    // }

    if (this.state.toggleAllRequests && this.state.phase1) {
      allRequests = this.state.allRequests.filter(
        (crf) =>
          crf.status !== "Draft"
      );
      //   
    }

    if (this.state.toggleAllRequests && this.state.phase2) {
      allRequests = this.state.allRequests.filter(
        (crf) =>
          crf.status === "In Process" ||
          crf.status === "Check Preparation" ||
          crf.status === "Check Prepared" ||
          crf.status === "Check Available" ||
          crf.status === "Check Released"
      );
    }

    if (this.state.toggleForTransmittal) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "For Transmittal"
      );
    }

    if (this.state.toggleForReview) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "For Review"
      );
    }

    if (this.state.toggleForEndorsement) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "For Endorsement"
      );
    }

    if (this.state.toggleReturned) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Returned"
      );
    }

    if (this.state.toggleRejected) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Rejected"
      );
    }

    if (this.state.toggleOnHold) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "On Hold"
      );
    }

    if (this.state.toggleInProcess) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "In Process"
      );
    }

    if (this.state.toggleCheckPreparation) {
      //   
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Check Preparation"
      );
    }

    if (this.state.toggleCheckPrepared) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Check Prepared"
      );
    }

    if (this.state.toggleCheckAvailable) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Check Available"
      );
    }

    if (this.state.toggleReleased) {
      allRequests = this.state.allRequests.filter(
        (crf) => crf.status === "Check Released"
      );
    }

    return (
      <CrfContext.Consumer>
        {(context) => (
          <div id="mainPage">
            <div id="sidePanel">
              <SideNav
                testState={context.state.testState}
                toggleBtn1List={context.toggleBtn1List}
                toggleBtn2List={context.toggleBtn2List}
                btn1List={context.state.btn1List}
                btn2List={context.state.btn2List}
                userRole={context.state.userRole}
              />
            </div>
            <div id="mainPanel">
              <TransitionsModal
                modalState={this.state.modalState}
                handleModal={this.handleModal}
                allRequests={this.state.allRequests}
                userRole="Requestor"
              />
              <div className="requestSelectionPanel">
                <div className="myRequestHeader">
                  <div className="myRequestHeader1Container">
                    <h1>My Requests</h1>
                    <div className="myRequestTools">
                      <button
                        onClick={this.handlePhase1}
                        id="ph1Btn"
                        className="ph1Btn"
                      >
                        Requests
                      </button>
                      <button
                        onClick={this.handlePhase2}
                        id="ph2Btn"
                        className="ph2Btn"
                      >
                        Checks
                      </button>
                      {/* <button
                        onClick={this.handleModal}
                        id='ph2Btn'
                        className='ph2Btn'
                      >
                        In Queue
                      </button> */}
                      {allRequests.length > 0 ? (
                        <button
                          onClick={() => {
                            if (this.state.phase1) {
                              DownloadPhase1(allRequests);
                            }
                            if (this.state.toggleInProcess) {
                              DownloadPhase2([allRequests, "in process"]);
                            }
                            if (this.state.toggleCheckPreparation) {
                              DownloadPhase2([
                                allRequests,
                                "check preparation",
                              ]);
                            }
                            if (this.state.toggleCheckPrepared) {
                              DownloadPhase2([allRequests, "check prepared"]);
                            }
                            if (this.state.toggleCheckAvailable) {
                              DownloadPhase2([allRequests, "check available"]);
                            }
                            if (this.state.toggleReleased) {
                              DownloadPhase2([allRequests, "released"]);
                            }
                          }}
                          id="ph2Btn"
                          className="ph2Btn"
                        >
                          Download as CSV
                        </button>
                      ) : null}
                    </div>
                  </div>
                  <div className="sortingButtons">
                    {this.state.phase1 === true ? (
                      <button onClick={this.handleAllRequest}>
                        <span id="allSelected" className="sortBtnInitital">
                          All Request
                        </span>
                      </button>
                    ) : (
                      <button
                        onClick={this.handleAllRequest}
                        style={displayNone}
                      >
                        <span id="allSelected" className="sortBtnInitital">
                          All Request
                        </span>
                      </button>
                    )}
                    {this.state.phase1 === true ? (
                      <>
                        <button onClick={this.handleApprovedRequest}>
                          <span id="approvedSelected" className="sortBtn">
                            For Transmittal
                          </span>
                        </button>
                        <button onClick={this.handleTransmittedRequest}>
                          <span id="transmittedSelected" className="sortBtn">
                            For Review
                          </span>
                        </button>
                        <button onClick={this.handleReviewedRequest}>
                          <span id="reviewedSelected" className="sortBtn">
                            For Endorsement
                          </span>
                        </button>
                        <button onClick={this.handleOnHoldRequest}>
                          <span id="onHoldSelected" className="sortBtn">
                            OnHold
                          </span>
                        </button>
                        <button onClick={this.handleForReturnedRequest}>
                          <span id="forEndorsementSelected" className="sortBtn">
                            Returned
                          </span>
                        </button>
                        <button onClick={this.handleForRejectedRequest}>
                          <span id="rejectedSelected" className="sortBtn">
                            Rejected
                          </span>
                        </button>
                      </>
                    ) : (
                      <>
                        <button onClick={this.handleInProcessRequest}>
                          <span id="inProcessSelected" className="sortBtn">
                            In Process
                          </span>
                        </button>
                        <button onClick={this.handleCheckPreparationRequest}>
                          <span
                            id="checkPreparationSelected"
                            className="sortBtn"
                          >
                            Check Preparation
                          </span>
                        </button>
                        <button onClick={this.handleCheckPreparedRequest}>
                          <span id="checkPreparedSelected" className="sortBtn">
                            Check Prepared
                          </span>
                        </button>
                        <button onClick={this.handleCheckAvailableRequest}>
                          <span id="checkAvailableSelected" className="sortBtn">
                            Check Available
                          </span>
                        </button>
                        <button onClick={this.handleReleasedRequest}>
                          <span id="releasedSelected" className="sortBtn">
                            Released
                          </span>
                        </button>
                      </>
                    )}
                  </div>

                  {/* TABLE HEAD */}
                  {this.renderHead()}
                  {/*END TABLE HEAD */}
                </div>
              </div>
              {/* TABLE DATA */}
              <div className="division"></div>
              {this.renderTableBody(allRequests)}
              <br />
            </div>
          </div>
        )}
      </CrfContext.Consumer>
    );
  }
}

const link = {
  textDecoration: "none",
  color: "black",
};

const displayNone = {
  display: "none",
};

export default MyRequest;
